import Class from './ClassNames';

function makePerformanceListItemHtml(data) {
  const {
    actionUrl,
    performanceTitle,
    displayTime,
    performanceStatusMessage,
    productTypeName,
    productTypeId,
  } = data;

  return `
    <li class="${Class.BASE}__day-event-list-item" data-tn-product-type-id="${productTypeId}">
      <a href="${actionUrl}" class="${Class.BASE}__event btn btn-primary">
        <span class="${Class.BASE}__event-name">${performanceTitle}</span>
        ${productTypeName ? `
          <span class="sr-only">,</span>
          <span class="tn-product-type-name">${productTypeName}</span>
        ` : ''
        }
        <span class="${Class.BASE}__event-time">
          <span class="sr-only">, </span>${displayTime}</span>
        </span>
        ${performanceStatusMessage ? `
          <span class="${Class.BASE}__event-status">
            <span class="sr-only">, </span>${performanceStatusMessage}
          </span>
        ` : ''
        }
      </a>
    </li>
  `;
}

const getDayLabelId = key => `tn-events-day-cell-${key}`;

function makePerformanceListHtml(perfs, dateKey) {
  const listItems = perfs.map(perf => makePerformanceListItemHtml(perf));

  return `
    <ul class="${Class.BASE}__day-event-list" aria-labelledby="${getDayLabelId(dateKey)}">
      ${listItems.join('')}
    </ul>
  `;
}

export {
  makePerformanceListItemHtml,
  makePerformanceListHtml,
  getDayLabelId,
};
